import { z } from 'zod';

export const AlertStatusSchema = z.enum([
  'OK',
  'Info',
  'Warning',
  'Tripped',
  'Critical',
]);

export type AlertStatus = z.infer<typeof AlertStatusSchema>;
